import z from "zod/v4";

export const getTrackingPagesMetrics = {
  name: "getTrackingPagesMetrics",
  input: z.object({
    numUnits: z.number().int().nonnegative(),
    startDate: z.date(),
  }),
  output: z.object({
    pages: z.array(
      z.object({
        trackingPageId: z.string(),
        opens: z.number(),
        clicks: z.number(),
        revenue: z.number(),
      }),
    ),
  }),
};
